import { CommonRegistry } from '../components/components';
import {
  CommonFilteredComponentSystem,
  FilteredComponentSystemUpdateEntityArgs,
} from './SystemBase';

/**
 * Copies input state from InputService to entity Input components.
 * Runs early in the frame to ensure all systems see consistent input state.
 *
 * For player-controlled entities, reads from InputService using playerId.
 * NPCs/AI can have their Input components set directly by AI systems.
 */
export class InputSyncSystem extends CommonFilteredComponentSystem {
  public componentClasses: (keyof CommonRegistry)[] = ['PlayerControlled', 'Input'];
  protected override skipDeadEntities = true;

  updateEntity({ world, entityId }: FilteredComponentSystemUpdateEntityArgs<CommonRegistry>): void {
    const playerControlled = world.getComponent(entityId, 'PlayerControlled')!;
    const input = world.getComponent(entityId, 'Input')!;

    const inputState = this.services.input.getState(playerControlled.playerId);

    // Copy all input values from InputService to the component
    const updates: Partial<typeof input> = {};
    let hasChanges = false;

    for (const key of Object.keys(inputState) as (keyof typeof inputState)[]) {
      if (key === 'corrections') continue;
      if (input[key] !== inputState[key]) {
        updates[key] = inputState[key];
        hasChanges = true;
      }
    }

    // Explicitly handle corrections to ensure they are cleared if missing in inputState
    // (Object.keys might skip 'corrections' if it's undefined in the service state)
    if (input.corrections !== inputState.corrections) {
      updates.corrections = inputState.corrections;
      hasChanges = true;
    }

    if (hasChanges) {
      this.updateComponent(entityId, input, updates);
    }
  }
}
